<script>
    import { formatPercent } from '../utils/format.js';
    // constants
    import parties from '../utils/parties';
    /** @type {string} */
    
    
    /** @type {string} */
    export let  name;
    /** @type {string} */
    export let  party;
    /** @type {number} */
    export let votes;
    /** @type {number} */
    export let  totalVotes;
    /** @type {boolean} */
    export let  isWinner;
    /** @type {boolean} */
    export let  isUncontested;
    /** @type {number} */
    export let  idx;
    /** @type {boolean} */
    export let isRunoff;

    $: PercentVotes = formatPercent(votes, totalVotes)

    </script>
    
    
    
    <td class="{(isWinner | isUncontested) ? party : 'oth'}"
        class:winner = {isWinner | isUncontested}
        class:desktop-only={idx==2}
        >
        <div class="summary-results__row-candidate">
            <span class="summary-results__row-name">
                {#if isWinner | isUncontested}
                    <span class="summary-results__candidate-winner">{'\u2713'}</span>
                {/if}
                {name}
                <span class="summary-results__row-party">
                    {#if parties[party].abbr}
                    {`(${parties[party].abbr})`}
                    {:else}
                    {`(${party.toLocaleUpperCase})`}
                    {/if}
                </span> 
                {#if isRunoff}
                <span class="candidate__cell-runoff candidate__">Runoff</span>
                {/if}             
            </span>
            <span class="summary-results__row-results">
                <span>{isUncontested ? '-' : PercentVotes}&nbsp;<span class="candidate__pct-symbol">%</span></span>
            </span>
        </div>
    </td>